import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
import Theme from "@adsk/alloy-react-theme";
import Modal from "@adsk/alloy-react-modal";
export var ModalComponent = styled(Modal)(
  templateObject_1 ||
    (templateObject_1 = __makeTemplateObject(
      ["\n  height: initial;\n  display: flex;\n"],
      ["\n  height: initial;\n  display: flex;\n"]
    ))
);
export var ModalHeader = styled(Modal.Header)(
  templateObject_2 ||
    (templateObject_2 = __makeTemplateObject(
      ["\n  min-height: 0px;\n"],
      ["\n  min-height: 0px;\n"]
    ))
);
export var ModalBody = styled(Modal.Body)(
  templateObject_3 ||
    (templateObject_3 = __makeTemplateObject(
      ["\n  padding: ", "px;\n"],
      ["\n  padding: ", "px;\n"]
    )),
  Theme.spacing.xLarge
);
export var FooterButton = styled.div(
  templateObject_4 ||
    (templateObject_4 = __makeTemplateObject(
      ["\n  display: flex;\n  margin-right: ", "px;\n"],
      ["\n  display: flex;\n  margin-right: ", "px;\n"]
    )),
  Theme.spacing.large
);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
